import React from "react";
import { Form, Input } from "antd";
import { intlPlaceholder } from "util/intlPlaceholder";
const PetMainCategoryForm = () => {
  return (
    <Form.Item
      className="gx-px-3"
      name="age"
      label={intlPlaceholder("age.filedName")}
      rules={[
        {
          required: true,
          message: "Age is required",
        },
      ]}
    >
      <Input placeholder={intlPlaceholder("age.filedName_Placeholder")} />
    </Form.Item>
  );
};

export default PetMainCategoryForm;
